import { useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

type Props = {
  onSubmit?: () => void;
};

export const useModEnter = ({ onSubmit }: Props = {}) => {
  const submitRef = useRef<HTMLButtonElement>(null);

  useHotkeys(
    'mod+enter',
    () => {
      if (submitRef?.current) submitRef.current.click();
      onSubmit?.();
    },
    { enableOnContentEditable: true, enableOnFormTags: true },
  );

  return submitRef;
};
